import React from "react";

const LeadRow = ({ _id, firmname, person, email, phone, plan, createdAt, country, name, message }) => {
  const isDigiCoffer = plan && plan.toLowerCase() === "digicoffer";
  const isLauditorOrDigiCoffer = plan && ['lauditor', 'digicoffer'].includes(plan.toLowerCase());
  
  const displayValue = isLauditorOrDigiCoffer ? country : plan;

  return (
    <tr key={_id}>
      <td>{isDigiCoffer ? name : firmname}</td>
      {!isDigiCoffer && <td>{person}</td>}
      <td>{email}</td>
      <td>{phone}</td>
      <td>{createdAt}</td>
      <td>{displayValue}</td>
      {isDigiCoffer && <td>{message}</td>}
    </tr>
  );
};

export default LeadRow;